import { render, staticRenderFns } from "./FundingDealsViz.vue?vue&type=template&id=2df5b40f&scoped=true&"
import script from "./FundingDealsViz.vue?vue&type=script&lang=js&"
export * from "./FundingDealsViz.vue?vue&type=script&lang=js&"
import style0 from "./FundingDealsViz.vue?vue&type=style&index=0&id=2df5b40f&lang=scss&scoped=true&"
import style1 from "./FundingDealsViz.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df5b40f",
  null
  
)

export default component.exports